/* =====================================================================================================
   mt-baukasten-hilfe.js - gemeinsame HILFSFUNKTIONEN für die zwei getrennten Baukästen (02.10.2026):
   sections/mt-farb-baukasten.liquid (Farb-Sets) und sections/mt-miniatur-baukasten.liquid (Panzerzug).
   Keine Karten, keine Betriebsarten - nur: Geldformat, Texte, Cookie-Schutz + Handy-Leiste + Blatt, mitlaufende
   PC-Spalte, Warenkorb-Aufruf mit den Shop-Events. Jede Section hat eigenes CSS und eigenes JS.
   ===================================================================================================== */
(function () {
  'use strict';
  if (window.MTBK) return;
  var html = document.documentElement;

  /* Geld wie Liquid | money in der jeweiligen Sprache: Muster aus {{ 123456 | money }} */
  function geldFormat(muster) {
    var GM = String(muster || '').match(/1(\D?)234(\D)56/);
    return function (c) {
      c = Math.round(c); var neg = c < 0; c = Math.abs(c);
      var ganz = String(Math.floor(c / 100)), rest = ('0' + (c % 100)).slice(-2);
      if (!GM) return (neg ? '-' : '') + ganz + ',' + rest + ' €';
      return (neg ? '-' : '') + String(muster).replace(GM[0], ganz.replace(/\B(?=(\d{3})+(?!\d))/g, GM[1]) + GM[2] + rest);
    };
  }
  function tx(T, k, w) { var s = T[k] || ''; Object.keys(w || {}).forEach(function (n) { s = s.split('[' + n + ']').join(w[n]); }); return s; }

  function cookieHoehe() {
    var c = document.getElementById('cookie-bar');
    if (!c) return 0;
    var cs = getComputedStyle(c);
    if (cs.visibility === 'hidden' || cs.display === 'none' || +cs.opacity < 0.05) return 0;
    var r = c.getBoundingClientRect();
    if (r.height < 1 || r.top >= innerHeight) return 0;
    return Math.max(0, Math.round(innerHeight - r.top));
  }

  /* Handy-Leiste + Blatt nach dem Muster snippets/mt-kaufleiste.liquid:
     an #root (außerhalb des Stapelkontexts von main#content), #root unten gepolstert, #totop hoch, --mt-float-bottom,
     rückt über die Cookie-Leiste, weg bei offener Schublade/Menü/Suche, bei offenem Blatt und solange der Abschlussblock
     im Bild ist. o = { leiste, blatt, hg, ende, anzahl: fn -> Zahl gewählter Stück } */
  function leiste(o) {
    var ziel = document.getElementById('root') || document.body;
    [o.hg, o.blatt, o.leiste].forEach(function (el) { ziel.appendChild(el); });
    var MQ = window.matchMedia('(max-width: 999px)');
    var endeSicht = false, letzteH = 0, oeffner = null;
    var zuKnopf = o.blatt.querySelector('[data-blatt-zu]');
    if (o.ende && 'IntersectionObserver' in window) new IntersectionObserver(function (es) { endeSicht = es[0].isIntersecting; lauf(); }).observe(o.ende);
    function lauf() {
      var blockiert = /(^|\s)(m6pn-open|m2a|search-full|search-full-mode)(\s|$)/.test(html.className);
      var an = MQ.matches && o.anzahl() > 0 && o.blatt.hidden && !blockiert && !endeSicht;
      var unten = cookieHoehe();
      o.leiste.hidden = !an;
      o.leiste.style.bottom = unten + 'px';
      html.classList.toggle('mbk-l-an', an);
      if (an) {
        var h = Math.ceil(o.leiste.getBoundingClientRect().height);
        if (h && h !== letzteH) { letzteH = h; html.style.setProperty('--mbk-l-h', h + 'px'); }
        html.style.setProperty('--mbk-l-ab', (unten + h) + 'px');
        html.style.setProperty('--mt-float-bottom', (unten + h + 8) + 'px');
      } else html.style.removeProperty('--mt-float-bottom');
      if (!MQ.matches && !o.blatt.hidden) zu();
    }
    function auf(ev) {
      oeffner = ev && ev.currentTarget || null;
      o.blatt.hidden = false; o.hg.hidden = false; html.style.overflow = 'hidden';
      lauf();
      try { zuKnopf.focus({ preventScroll: true }); } catch (e) {}
    }
    function zu() {
      if (o.blatt.hidden) return;
      o.blatt.hidden = true; o.hg.hidden = true; html.style.overflow = '';
      lauf();
      if (oeffner && !o.leiste.hidden) { try { oeffner.focus({ preventScroll: true }); } catch (e) {} }
    }
    o.leiste.querySelector('[data-blatt-auf]').addEventListener('click', auf);
    zuKnopf.addEventListener('click', zu);
    o.hg.addEventListener('click', zu);
    document.addEventListener('keydown', function (ev) {
      if (o.blatt.hidden) return;
      if (ev.key === 'Escape') { zu(); return; }
      if (ev.key === 'Tab') {
        var f = [].slice.call(o.blatt.querySelectorAll('button:not([disabled]),a[href]')).filter(function (x) { return x.offsetParent; });
        if (!f.length) return;
        if (ev.shiftKey && document.activeElement === f[0]) { ev.preventDefault(); f[f.length - 1].focus(); }
        else if (!ev.shiftKey && document.activeElement === f[f.length - 1]) { ev.preventDefault(); f[0].focus(); }
      }
    });
    if (MQ.addEventListener) MQ.addEventListener('change', lauf);
    return { lauf: lauf, zu: zu };
  }

  /* PC ab 1000 px: Zusammenfassung in eigener Spalte, läuft mit (sticky greift im Theme nicht), nie über Karten oder
     unter dem Kopf. Kopf: von oben abtasten und über jedes feste Fremd-Element springen, ohne Cache (Kopf wechselt die Höhe). */
  function spalte(root, sp, box) {
    var MQD = window.matchMedia('(min-width: 1000px)');
    function fremdFix(el) {
      for (var x = el; x && x !== document.body && x !== html; x = x.parentElement) {
        if (root.contains(x) || x.id === 'cookie-bar') return null;
        var p = getComputedStyle(x).position;
        if (p === 'fixed' || p === 'sticky') return x;
      }
      return null;
    }
    function kopfUnten() {
      var r = sp.getBoundingClientRect(), x = Math.round(r.left + r.width / 2), y = 0;
      for (var i = 0; i < 8 && y < innerHeight / 2; i++) {
        var el = document.elementFromPoint(x, y + 1), fx = el && fremdFix(el);
        if (!fx) break;
        y = Math.max(y + 2, Math.ceil(fx.getBoundingClientRect().bottom));
      }
      return y;
    }
    function lauf() {
      if (!sp || !box) return;
      if (!MQD.matches) { box.classList.remove('is-fix', 'is-unten'); box.style.left = ''; return; }
      var oben = kopfUnten() + 16;
      var sr = sp.getBoundingClientRect();
      var liste = box.querySelector('[data-z-liste], [data-z-slots]');
      var frei = innerHeight - oben - 16 - cookieHoehe();
      var rest = box.offsetHeight - (liste ? liste.offsetHeight : 0);
      box.style.setProperty('--mbk-lmax', Math.max(140, frei - rest) + 'px');
      var bh = box.offsetHeight;
      box.classList.remove('is-fix', 'is-unten');
      box.style.left = '';
      if (sr.top >= oben) return;
      if (sr.bottom - bh - 12 <= oben) { box.classList.add('is-unten'); return; }
      box.style.setProperty('--mbk-top', oben + 'px');
      box.style.setProperty('--mbk-w', sr.width + 'px');
      box.style.left = sr.left + 'px';
      box.classList.add('is-fix');
    }
    if (MQD.addEventListener) MQD.addEventListener('change', lauf);
    return { lauf: lauf };
  }

  /* Scroll/Resize-Takt für beide Läufe (rAF + Nachlauf 260 ms, wie in reference_theme_sticky_und_anker_fallen) */
  function takt(fn) {
    var geplant = false, nachlauf = null;
    function planen() {
      if (!geplant) { geplant = true; requestAnimationFrame(function () { geplant = false; fn(); }); }
      clearTimeout(nachlauf); nachlauf = setTimeout(fn, 260);
    }
    window.addEventListener('scroll', planen, { passive: true });
    window.addEventListener('resize', planen);
    new MutationObserver(planen).observe(html, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('click', function () { setTimeout(planen, 400); setTimeout(planen, 1200); }, true);
    var n = 0, t = setInterval(function () { planen(); if (++n > 60) clearInterval(t); }, 1000);
    return planen;
  }

  /* Warenkorb wie der Katalog (assets/mt-filter.js): /cart/add.js, dann cart:updated + cart:item-added
     (Empfänger snippets/side-cart-container.liquid). Fehler über showAlert (Empfänger assets/custom.js). Kein eigenes Fenster. */
  function inDenKorb(rootUrl, items) {
    var R = String(rootUrl || '/'); if (R.slice(-1) !== '/') R += '/';
    return fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }, function () { return { ok: res.ok, d: {} }; }); })
      .then(function (res) {
        if (!res.ok || (res.d && res.d.status)) throw new Error((res.d && (res.d.description || res.d.message)) || '');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:item-added'));
        return res.d;
      });
  }
  function meldeFehler(text) { window.dispatchEvent(new CustomEvent('showAlert', { detail: { message: text, type: 'error' } })); }
  function ansage(el, s) { if (el) { el.textContent = ''; setTimeout(function () { el.textContent = s; }, 60); } }

  window.MTBK = { geldFormat: geldFormat, tx: tx, cookieHoehe: cookieHoehe, leiste: leiste, spalte: spalte, takt: takt, inDenKorb: inDenKorb, meldeFehler: meldeFehler, ansage: ansage };
})();
